export function Footer() {
  return (
    <footer className="fixed bottom-0 w-full bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-t">
      <div className="w-full flex h-14 items-center justify-between px-4">
        <div className="flex items-center">
          <span className="text-xs text-muted-foreground">CLC Sign v.1.8.6  by <a href="https://idiliq.dev" target="_blank" rel="noopener noreferrer">IDILIQ Dev</a></span>
        </div>
        <div className="flex items-center">
          <img 
            src="/clc-world-blue.png" 
            alt="CLC World Blue" 
            className="w-auto" 
            style={{ maxWidth: '15%' }} 
          />
        </div>
      </div>
    </footer>
  )
}